import React, { Fragment } from 'react'

import Layout from '../components/Layout'
import {PasswordForgetForm} from '../components/Authentication'

const PasswordForgetPage = () => (
    <Fragment>
        <h1>PasswordForget</h1>
        <PasswordForgetForm />
    </Fragment>
)

export default ({ location }) => (
    <Layout location={location}>
        <PasswordForgetPage />
    </Layout>
)
